import AuthService from "../auth/authService";

const Logout = () => {
  return <button onClick={AuthService.logout}>Logout</button>;
};

export default Logout;
